import { isEmpty } from "lodash";
import { v4 as uuidv4 } from "uuid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import moment from "moment";

import { NormalOptionTile, LinkOptionTile, PriceInputOptionTile, DatePickerOptionTile, SubTitleRow, ButtonComp } from "components";
import {
  getActiveOptionComp,
  getFilterOptions,
  selectIsDisabled,
  selectLabelItems,
  selectModuleName,
  setActiveOptionComp,
  setModuleName,
  setShowAllOptions,
  getCustomButtons,
  getShowFaq,
  getEnabledScheduleTour,
  getQualificationButtonEnabled,
  setReplies,
  addNewMessage,
  selectPromotionOffer,
  setPromotionOffer,
  selectAPIKey,
  setIsDisabled,
  removeAndAddMessages,
} from "slices";
import { INITIAL_REPLY_OPTIONS, convertToCamelCase, EXPLORE_MORE_OPTION, CUSTOM_BUTTON } from "utils";
import { getVisiblePhotos, getVisibleVideos, selectPropertyId } from "slices/property-slice/index";
import { createEventSignal, getPromotionInfo, sendHayleyMessage } from "utils/methods/index";
import { getAppSSID } from "slices/window-slice/index";
import { ERROR_MSG, EVENT_Keys, EVENT_TAGS } from "utils/constants/index";

const BoxView = ({ replies, onClick, fromAMA }) => {
  const dispatch = useDispatch();
  const prevLabel = useSelector(selectLabelItems);
  const module = useSelector(selectModuleName);
  const optionDisabled = useSelector(selectIsDisabled);
  const filterOptions = useSelector(getFilterOptions);
  const activeOptionComp = useSelector(getActiveOptionComp);
  const customButtons = useSelector(getCustomButtons);
  const isShowAMA = useSelector(getShowFaq);
  const schedularFormEnabled = useSelector(getEnabledScheduleTour);
  const qualification_button_enabled = useSelector(getQualificationButtonEnabled);
  const ifVideosExist = useSelector(getVisibleVideos);
  const ifPhotosExist = useSelector(getVisiblePhotos);
  const [options, setOptions] = useState({});
  const promotionOffer = useSelector(selectPromotionOffer);
  const SSID = useSelector(getAppSSID);
  const propertyId = useSelector(selectPropertyId);
  const apiKey = useSelector(selectAPIKey);

  const onClickNormalOptionTile = (
    key,
    message,
    nextOptionsType,
    disablePlaceholderMessage,
    callbackOptions,
    data,
    label,
    event,
    customBtnText,
    customBtnLabel,
    customBtnId
  ) => {
    if (label === "specialOffers") {
      if (!propertyId || !apiKey) {
        return;
      }

      const now = new Date().toISOString();
      const timestampedMsgs = message.map((i) => ({ ...i, createdAt: now }));

      dispatch(addNewMessage([...timestampedMsgs, { message: label, speaker: "user", createdAt: now }]));

      dispatch(addNewMessage([{ message: "loading", speaker: "bot", createdAt: now }]));

      dispatch(setIsDisabled(true));

      getPromotionInfo(propertyId, apiKey)
        .then(({ data: offers }) => {
          dispatch(setPromotionOffer(offers));

          sendHayleyMessage({
            text: t(label),
            queryType: "question",
            ownerType: "prospect",
            kgNodeValue: t(label),
          });

          window.parent.postMessage(
            JSON.stringify({
              event_name: "h_click",
              event_params: {
                h_page_type: "hayley",
                h_clicked_location: "community info",
                h_stream: "hyly",
                h_display_method: "iframe",
                h_click_value: "offer",
              },
            }),
            "*"
          );

          sendHayleyMessage({
            text: t("hereSpecialOffers"),
            queryType: "answer",
            ownerType: "agent",
            kgNodeValue: t("hereSpecialOffers"),
          });

          const nextMsgs = [
            ...timestampedMsgs,
            {
              key: "special_offer",
              message: "hereSpecialOffers",
              speaker: "bot",
              createdAt: new Date().toISOString(),
            },
            {
              key: "special_offer",
              message: "",
              speaker: "comp",
              createdAt: new Date().toISOString(),
            },
          ];

          dispatch(removeAndAddMessages(nextMsgs));
          dispatch(setIsDisabled(false));
        })
        .catch((error) => {
          dispatch(addNewMessage([{ message: ERROR_MSG, speaker: "bot", createdAt: new Date().toISOString() }]));
          dispatch(setIsDisabled(false));
        });

      return;
    }

    if (label == "cancel") {
      sendHayleyMessage({
        text: "Cancel",
        queryType: "question",
        ownerType: "prospect",
        kgNodeValue: "Cancel",
      });

      let previousMsgs = message.map((i) => ({ ...i, createdAt: new Date().toISOString() }));

      const nex = [
        ...previousMsgs,
        {
          message: "howHelp",
          speaker: "bot",
          createdAt: new Date().toISOString(),
        },
      ];

      dispatch(addNewMessage(nex));

      const reply = {
        title: "",
        options: [],
        optionLabel: "",
        optionsType: "Init",
        checkStorage: false,
        disableResetBox: true,
        renderType: "boxView",
      };

      dispatch(setReplies(reply));

      sendHayleyMessage({
        text: t("howHelp"),
        queryType: "answer",
        ownerType: "agent",
        kgNodeValue: t("howHelp"),
      });

      return;
    }

    let eventKeys = JSON.parse(localStorage.getItem(`events_${SSID}`)) || [];
    eventKeys.push(EVENT_Keys[key]);
    localStorage.setItem(`events_${SSID}`, JSON.stringify(eventKeys));
    // if (key == "exploreMore") {
    // const from = typeof data === "string" ? data : null;
    // formatMessageEdit("Init", label, from);

    //   return;
    // }

    const eventHash = {
      event_name: event,
      event_params: {
        h_page_type: "hayley",
        h_clicked_location: key,
        h_stream: "hyly",
        h_display_method: "iframe",
        h_click_value: label,
      },
    };

    const requestOption = {
      tag: EVENT_TAGS[key],
      metric: "Click",
      propertyId: propertyId,
      sessionId: SSID,
      appSubsection: EVENT_Keys[key],
    };
    createEventSignal(requestOption);
    dispatch(setActiveOptionComp(null));

    const replyOptionData = INITIAL_REPLY_OPTIONS.find((item) => item.key === key);

    if (replyOptionData) {
      dispatch(setModuleName(replyOptionData.key));
    }

    if (!replyOptionData && module === "schedule_tour" && key === "schedule_tour") {
      eventHash.event_params.h_tour_type =
        callbackOptions?.data?.name === "appointment_type" ? convertToCamelCase(callbackOptions?.data?.data) : convertToCamelCase(prevLabel.appointment_type);

      if (callbackOptions?.data?.name !== "appointment_type") {
        eventHash.event_params.h_start_date = callbackOptions?.data?.name === "date" ? callbackOptions?.data?.data : prevLabel.date;

        if (callbackOptions?.data?.name !== "date") {
          eventHash.event_params.h_start_time =
            callbackOptions?.data?.name === "time" ? moment(callbackOptions?.data?.data).format("HH:mm a") : moment(prevLabel.time).format("HH:mm a");
        }
      }
    }

    const sequence = JSON.parse(localStorage.getItem(`events_${SSID}`));

    if (sequence.length > 3) {
      const metadata = {
        sequence: sequence,
      };
      const jsonString = JSON.stringify(metadata);

      const requestOption = {
        tag: "PROSPECT_CLICK_SEQUENCE",
        metric: "Click",
        propertyId: propertyId,
        sessionId: SSID,
        appSubsection: "list of clicks",
        metaData: `${jsonString.replace(/"/g, '\\"')}`,
      };
      createEventSignal(requestOption);
    }

    window.parent.postMessage(JSON.stringify(eventHash), "*");

    onClick(
      message,
      nextOptionsType,
      disablePlaceholderMessage,
      callbackOptions,
      data,
      null,
      null,
      customBtnText,
      customBtnLabel,
      customBtnId,
      label == "asap"
    );
  };

  const addSpecialOffer = (options = [], promotionOffer = {}) => {
    if (promotionOffer?.description && Array.isArray(options)) {
      const special = {
        content: {
          component: "NormalOptionTile",
          componentOptions: {
            icon: null,
            label: "specialOffers",
            type: "quickActions",
          },
        },
        message: [],
        nextOptionsType: "customButton",
      };

      options.push(special);
    }

    return options;
  };

  useEffect(() => {
    let arr = INITIAL_REPLY_OPTIONS.filter((v) => !filterOptions?.includes(options[v]?.key));
    let arr2 = replies.options.filter((v) => !filterOptions?.includes(options[v]?.key));

    if (!schedularFormEnabled) {
      arr = arr.filter((op) => op.key !== "schedule_tour");
      arr2 = arr2.filter((op) => op.key !== "schedule_tour");
    }

    if (!qualification_button_enabled) {
      arr = arr.filter((op) => op.key !== "do_i_qualify");
      arr2 = arr2.filter((op) => op.key !== "do_i_qualify");
    }

    if (!ifVideosExist) {
      arr = arr.filter((op) => op.key !== "videos");
      arr2 = arr2.filter((op) => op.key !== "videos");
    }

    if (!ifPhotosExist) {
      arr = arr.filter((op) => op.key !== "photos");
      arr2 = arr2.filter((op) => op.key !== "photos");
    }

    if (arr.length && fromAMA) {
      if (!isEmpty(customButtons) && !isEmpty(customButtons[0])) {
        customButtons.forEach((custom_button) => {
          if (!custom_button.state) {
            return;
          }

          let button = JSON.parse(JSON.stringify(CUSTOM_BUTTON));
          button.content.componentOptions.label = custom_button?.button_label;
          button.content.component = custom_button?.action === "url" ? button.content.component : "NormalOptionTile";
          button.nextOptionsType = custom_button?.action === "markdown" ? "customButton" : null;
          button.content.componentOptions.icon = custom_button?.action === "url" ? button.content.componentOptions.icon : null;
          button.content.componentOptions.id = custom_button?.id;

          if (custom_button.action === "url") {
            button.content.componentOptions.link = custom_button?.url;
          } else {
            button.content.componentOptions.text = custom_button?.text;
          }

          arr.push(button);
        });
      }

      let dataArrays = {};

      let newOptions = addSpecialOffer(arr, promotionOffer);

      newOptions.forEach((v) => {
        const key = v.content.componentOptions.type || "";

        if (dataArrays[key]) {
          dataArrays[key] = [...dataArrays[key], v];
        } else {
          dataArrays[key] = [v];
        }
      });

      setOptions(dataArrays);
    } else if (replies?.optionsType === "Init") {
      const data = arr.filter((v) => ["find_home", "schedule_tour"].includes(v.key));

      if (isShowAMA) {
        setOptions({
          "": [...data, EXPLORE_MORE_OPTION],
        });
      } else {
        const newOptions = addSpecialOffer(arr, promotionOffer);

        if (!isEmpty(customButtons) && !isEmpty(customButtons[0])) {
          customButtons.forEach((custom_button) => {
            if (!custom_button.state) {
              return;
            }

            let button = JSON.parse(JSON.stringify(CUSTOM_BUTTON));
            button.content.componentOptions.label = custom_button?.button_label;
            button.content.component = custom_button?.action === "url" ? button.content.component : "NormalOptionTile";
            button.nextOptionsType = custom_button?.action === "markdown" ? "customButton" : null;
            button.content.componentOptions.icon = custom_button?.action === "url" ? button.content.componentOptions.icon : null;
            button.content.componentOptions.id = custom_button?.id;

            if (custom_button.action === "url") {
              button.content.componentOptions.link = custom_button?.url;
            } else {
              button.content.componentOptions.text = custom_button?.text;
            }

            newOptions.push(button);
          });
        }

        setOptions({
          "": [...newOptions],
        });
      }
    } else {
      setOptions({
        "": arr2,
      });
    }
  }, [replies, fromAMA]);

  const marginClass = "hayley-mr-2 hayley-mb-2";

  return (
    <div
      data-testid="main-menu-options-container"
      className={`${replies.optionsType === "customButton" ? "" : "hayley-flex"} hayley-w-full hayley-flex-wrap hayley-items-center`}
    >
      {fromAMA ? null : (
        <>
          {!isEmpty(replies.title) ? (
            <div
              dangerouslySetInnerHTML={{ __html: t(replies.title) }}
              className="hayley-mb-3 hayley-w-full hayley-flex-none hayley-text-sm hayley-text-black"
            />
          ) : null}
        </>
      )}

      <div data-testid="main-menu-options" className={`${fromAMA ? "hayley-p-4" : ""}`}>
        {Object.keys(options || {}).map((v, i) => {
          return (
            <div key={i} className="hayley-flex hayley-flex-col">
              {v ? <span className="hayley-my-3 hayley-text-sm hayley-font-semibold hayley-text-custom-4">{t(v)}</span> : null}

              <div data-testid="bubbles-container" className={`hayley-flex hayley-flex-wrap`}>
                {options[v]?.map(({ content: { component, componentOptions }, key, message, nextOptionsType, disablePlaceholderMessage, data, event }) => {
                  if (component === "SubTitleRow") {
                    return <SubTitleRow title={componentOptions.title} key={uuidv4()} />;
                  }

                  if (component === "NormalOptionTile") {
                    const msg = message?.map((v) => ({
                      ...v,
                      optionsType: fromAMA || replies.optionsType === "customButton" ? "Init" : v.optionsType || replies.optionsType,
                      key: key,
                    }));
                    const customBtnText = componentOptions.text;
                    const customBtnLabel = componentOptions.label;

                    return (
                      <NormalOptionTile
                        key={uuidv4()}
                        icon={isShowAMA ? componentOptions.icon : false}
                        label={componentOptions.label}
                        classes={marginClass}
                        onClick={(e) => {
                          // if (replies?.optionsType === "Init" && key == "exploreMore") {
                          if (key == "exploreMore" && isShowAMA) {
                            e.stopPropagation();

                            dispatch(setShowAllOptions(true));
                          } else {
                            dispatch(setShowAllOptions(false));

                            onClickNormalOptionTile(
                              key,
                              msg,
                              nextOptionsType,
                              disablePlaceholderMessage,
                              componentOptions.callbackOptions,
                              data,
                              componentOptions.label,
                              event,
                              customBtnText,
                              customBtnLabel,
                              componentOptions.id
                            );
                          }
                        }}
                        disabled={optionDisabled}
                      />
                    );
                  }

                  if (component === "RangeSlider") {
                    return (
                      <ButtonComp
                        key={uuidv4()}
                        className={marginClass}
                        rounded={true}
                        label={t("customRange")}
                        selected={componentOptions?.label === activeOptionComp?.label}
                        onClick={() => {
                          dispatch(setActiveOptionComp({ label: componentOptions?.label, componentOptions, optionsType: replies.optionsType }));
                        }}
                        testId={componentOptions.label}
                      />
                    );
                  }

                  if (component === "DatePickerOptionTile") {
                    return (
                      <DatePickerOptionTile
                        key={uuidv4()}
                        compKey={key}
                        disabled={optionDisabled}
                        optionsType={replies.optionsType}
                        classes={marginClass}
                        componentOptions={componentOptions}
                        onDateClick={(newMessage, callbackOptions) =>
                          onClick(
                            newMessage,
                            nextOptionsType,
                            disablePlaceholderMessage,
                            callbackOptions,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            true
                          )
                        }
                      />
                    );
                  }

                  if (component === "LinkOptionTile") {
                    return (
                      <LinkOptionTile
                        key={uuidv4()}
                        icon={componentOptions.icon}
                        label={componentOptions.label}
                        classes={marginClass}
                        onClick={() => {
                          if (!isEmpty(componentOptions.link)) {
                            window.open(
                              componentOptions.link.includes("https://") || componentOptions.link.includes("https://")
                                ? componentOptions.link
                                : `https://${componentOptions.link}`,
                              "_blank"
                            );
                          } else {
                            const requestOption = {
                              tag: "NO_DATA_SHOWN",
                              metric: "Surprise",
                              propertyId: propertyId,
                              sessionId: SSID,
                              appSubsection: componentOptions.label,
                              metaData: ``,
                            };
                            createEventSignal(requestOption);
                            alert("Sorry, I can't find the link you're looking for.");
                          }
                        }}
                        disabled={optionDisabled}
                      />
                    );
                  }

                  if (component === "PriceInputOptionTile") {
                    return (
                      <PriceInputOptionTile
                        key={uuidv4()}
                        placeholder={componentOptions.placeholder || ""}
                        disabled={optionDisabled}
                        componentOptions={componentOptions}
                        onClick={(newMessage, callbackOptions) => onClick(newMessage, nextOptionsType, disablePlaceholderMessage, callbackOptions)}
                      />
                    );
                  }

                  return <React.Fragment key={uuidv4()} />;
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BoxView;
